import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';

export type TrackAssetModalThemeToggle = {
  theme: 'dark' | 'light';
};

export const useTrackAssetModalThemeToggle = () => {
  const { track } = useAnalyticsUtilities();

  const trackAssetModalThemeToggle = useCallback(
    (params: TrackAssetModalThemeToggle) => {
      track(`Closed asset details modal`, params);
    },
    [track],
  );

  return { trackAssetModalThemeToggle };
};
